import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Link, Route, Routes } from 'react-router';
import './index.css';
import { Layout } from './components/Layout';
import { Card, Empty } from './components/ui';
import { AuthProvider, RequireAuth } from './lib/auth';
import { AccountDetail, AccountHealthPage, AccountsList, AdoptionPage } from './pages/Accounts';
import { Install } from './pages/Install';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { Realtime } from './pages/Realtime';
import { GlobalSettings, SiteSettings } from './pages/Settings';
import { SiteLayout } from './pages/SiteLayout';
import { Sites } from './pages/Sites';

function NotFound() {
  return (
    <Card>
      <Empty title="There is nothing at this address">
        <Link to="/" className="text-totum-ink hover:underline">Back to sites</Link>
      </Empty>
    </Card>
  );
}

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route index element={<Sites />} />
            <Route path="sites" element={<Sites />} />
            <Route path="settings" element={<GlobalSettings />} />
            <Route path="sites/:id" element={<SiteLayout />}>
              <Route index element={<Overview />} />
              <Route path="realtime" element={<Realtime />} />
              <Route path="accounts" element={<AccountsList />} />
              <Route path="accounts/health" element={<AccountHealthPage />} />
              <Route path="accounts/adoption" element={<AdoptionPage />} />
              <Route path="accounts/:ref" element={<AccountDetail />} />
              <Route path="install" element={<Install />} />
              <Route path="settings" element={<SiteSettings />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
